export default "__VITE_ASSET__Du$18qZu__"